import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Box, Skeleton } from "@mui/material";
import AppLayout from "../components/AppLayout";
import BoxComponent from "../components/BoxTile";
import LoadAgentDialogBox from "../components/LoadAgentDialogBox";
import "../css/NewAgenSelectorScreen.css"; // Apply the CSS file
import { loadAIAgents } from "../redux/slices/LoadAIAgentsSlice";
import { getSystemAiagents } from "../redux/slices/ActiveSystemAiAgentLists";
import { getProfile } from "../redux/slices/ProfileSlice";
import { clearCsvData } from '../redux/slices/CSVDataSlice';
import {getImages} from '../utills/lib'; // Ensure this utility function is correctly imported

const AgentListDashboard = () => {
  const { activieSystemAiAgentList, activieSystemAiAgentListLoading } = useSelector(
    (state) => state.ActiveSystemAiAgentLists
  );
  const { profileDetails, profileDetailsLoading } = useSelector(
    (state) => state.ProfileSlice
  );
  console.log('profileDetails',profileDetails)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    loadMyAgents();
    dispatch(clearCsvData())

  }, []);

  const loadMyAgents = async () => {
    dispatch(loadAIAgents());
    dispatch(getSystemAiagents());
    dispatch(getProfile())
  };

  const onPress = (item) => {
    navigate("/invoiceAgents",{state:item});
  };

  // Custom Button Component
  const CustomButton = () => {
    const [hover, setHover] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const openDialog = () => setDialogOpen(true);
    const closeDialog = () => setDialogOpen(false);

    return activieSystemAiAgentListLoading ? (
      <Skeleton variant="rectangular" width={180} height={46} sx={{ borderRadius: "20px", margin: "16px 0" }} />
    ) : (
      <Box>
        <Button
          variant="outlined"
          sx={{
            fontSize: "12px",
            fontWeight: 700,
            fontFamily: "'Mulish', sans-serif",
            borderRadius: "20px",
            border: "2px solid #1D3899",
            backgroundColor: "transparent",
            color: "#1D3899",
            padding: "8px 16px",
            width: "180px",
            height: "46px",
            "&:hover": {
              backgroundColor: "#1D3899",
              color: "white",
            },
          }}
          onClick={()=>navigate('/LoadMyAgent')}
          startIcon={
            <img
              src={require("../assets/images/share.png")}
              alt="Custom Icon"
              style={{
                width: 20,
                height: 20,
                backgroundColor: hover ? "#fff" : "transparent",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            />
          }
        >
          Load My Agent
        </Button>
        <LoadAgentDialogBox  open={dialogOpen} onClose={closeDialog} />
      </Box>
    );
  };

  // Agent List Component with Skeleton
  const AgentList = ({ activieSystemAiAgentList }) => {
    if (activieSystemAiAgentListLoading || profileDetailsLoading) {
      return (
        <div className="agent-list-container">
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={200}
              height={120}
              sx={{ borderRadius: "8px", marginBottom: "16px" }}
            />
          ))}
        </div>
      );
    }

    return (
      <div className="agent-list-container">
        {activieSystemAiAgentList.map((box) => (
          <BoxComponent
            onPress={()=>onPress(box)}
            key={box.id}
            backgroundColor={box.backgroundColor}
            image={getImages(box.slug)}
            title={box.name}
            subtitle={box.description}
            className="box-component"
          />
        ))}
      </div>
    );
  };

  return (
    <AppLayout>
      <CustomButton />
      <h2 className="custom-title">Create New Agent</h2>
      <AgentList activieSystemAiAgentList={activieSystemAiAgentList} />
    </AppLayout>
  );
};

export default AgentListDashboard;
